import React from "react";
import { Card as CardType } from "../types";
import Card from "./Card";
import CardSlot from "./CardSlot";

interface CurrentCardProps {
  card: CardType | null;
  isSelected: boolean;
  onClick: () => void;
}

export const CurrentCard: React.FC<CurrentCardProps> = ({
  card,
  isSelected,
  onClick,
}) => {
  return (
    <CardSlot isSelected={isSelected} onClick={onClick}>
      {card && <Card card={card} />}
    </CardSlot>
  );
};

export default CurrentCard;
